// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_ZbA","content":"styles_content__2qO-6","row":"styles_row__2eIZ6","footer":"styles_footer__3r7ws","phraseLength":"styles_phraseLength__3x5q8"};